import { render, staticRenderFns } from "./DropdownFooter.vue?vue&type=template&id=71f67e5b&scoped=true&"
import script from "./DropdownFooter.vue?vue&type=script&lang=js&"
export * from "./DropdownFooter.vue?vue&type=script&lang=js&"
import style0 from "./DropdownFooter.vue?vue&type=style&index=0&id=71f67e5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f67e5b",
  null
  
)

export default component.exports